(function() {
    const container = document.querySelector('fieldset.js.product-form__input.product-form__input--color');
    const label = container?.querySelector('.form__label, legend');
    if (!container || !label) return;

    const maxAllowedHeight = 123;
    const defaultPadding = '15px';

    Object.assign(container.style, {
        maxHeight: `${maxAllowedHeight}px`,
        overflow: 'hidden',
        paddingBottom: defaultPadding,
        transition: 'max-height 0.3s ease'
    });

    setTimeout(() => {
        if (container.scrollHeight > (maxAllowedHeight + 10)) {
            const count = container.querySelectorAll('input').length;
            const btn = document.createElement('span');

            btn.textContent = `View All (${count})`;
            label.style.position = 'relative';

            Object.assign(btn.style, {
                position: 'absolute',
                right: '0',
                top: '0',
                cursor: 'pointer',
                textDecoration: 'underline',
                fontSize: '12px',
                fontWeight: '400',
                textTransform: 'none',
                zIndex: '10'
            });

            btn.addEventListener('click', () => {
                container.style.maxHeight = 'none';
                container.style.overflow = 'visible';
                container.style.paddingBottom = '0';
                btn.remove();
            });

            label.appendChild(btn);
        } else {
            container.style.maxHeight = 'none';
            container.style.paddingBottom = defaultPadding;
        }
    }, 50);
})();

(function() {
    const containerSelector = '.product__modal-opener--image';
    let isZoomed = false;

    document.addEventListener('mouseover', (e) => {
        const container = e.target.closest(containerSelector);
        if (container) container.style.cursor = 'zoom-in';
    });

    document.addEventListener('click', (e) => {
        const container = e.target.closest(containerSelector);
        if (!container) return;

        isZoomed = !isZoomed;
        const img = container.querySelector('img');
        if (!img) return;

        if (isZoomed) {
            container.style.cursor = 'zoom-out';
            applyZoom(e, container, img);
        } else {
            container.style.cursor = 'zoom-in';
            img.style.transform = 'scale(1)';
        }
    });

    document.addEventListener('mousemove', (e) => {
        if (!isZoomed) return;
        const container = e.target.closest(containerSelector);
        const img = container?.querySelector('img');
        if (container && img) applyZoom(e, container, img);
    });

    document.addEventListener('mouseout', (e) => {
        const container = e.target.closest(containerSelector);
        if (container && !e.relatedTarget?.closest(containerSelector)) {
            isZoomed = false;
            const img = container.querySelector('img');
            if (img) img.style.transform = 'scale(1)';
            container.style.cursor = 'zoom-in';
        }
    });

    function applyZoom(e, container, img) {
        if (container.style.overflow !== 'hidden') container.style.overflow = 'hidden';
        img.style.transition = 'transform 0.1s ease-out';
        const rect = container.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = `${x}% ${y}%`;
        img.style.transform = 'scale(2.5)';
    }
})();